module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo4.11c790fe.png";